module.exports = __webpack_public_path__ + "static/media/fall.1084711a.jpg";